import axios from 'axios'

/**
 * @function funcName funcName's description
 * @param {string} businessId - what the param does
 * @param {string} nrctUID - user's current neighborhood id
 * @param {string} jwt - user's jwt token
 * @returns {Promise} Promise object represents
 */
export const indexFaq = () => {
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/faq`)
      .then((res) => resolve(res.data.body))
      .catch((err) => {
        reject(err)
      })
  })
}

export const rawMainServerUrlBuilder = (route) => {
  return `${process.env.REACT_APP_BACKEND_URL}${route}`
}

export const rawBusinessServerUrlBuilder = (route) => {
  return `${process.env.REACT_APP_BUSINESS_URL}${route}`
}

export const axiosRequestInterceptorBuilder = (requestHandler, errorHandler) => {
  return axios.interceptors.request.use(
    requestHandler,
    errorHandler
  )
}

export const axiosResponseInterceptorBuilder = (responseHandler, errorHandler) => {
  return axios.interceptors.response.use(
    responseHandler,
    errorHandler
  )
}

export const axiosEjectInterceptor = (requestId, responseId) => {
  axios.interceptors.request.eject(requestId)
  axios.interceptors.response.eject(responseId)
}
